import styled from 'styled-components';

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 200px;
  width: 100%;
  max-width: 400px;
  text-align: left;


  @media (max-width: 600px) {
    width: 100%;
    align-items: center;
    margin: 0 auto;
  }
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  @media (max-width: 600px) {
    width: 100%;
    max-width: 300px;
    justify-content: center;
    gap: 16px;
  }
`;

export const InfoLabel = styled.span`
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  font-family: "Red Hat Display", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%

  @media (max-width: 600px) {
    &:after {
      content: ':';
    }
  }
`;

export const InfoValue = styled.span`
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  font-size: 14px;
  font-weight: 700;
  line-height: 130%;
  
  &.truncate {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 600px) {
      text-align: left;
      max-width: 60%;
    }
  }
`;

export const BlockchainLink = styled.a`
  color: ${({ theme }) => theme?.colors?.text?.link};
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  display: block;
  margin-bottom: 8px;

  &:hover {
    text-decoration: underline;
  }
`;

export const Description = styled.p`
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  font-family: "Red Hat Display", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 650px;

  @media (max-width: 600px) {
    max-width: 500px;
    text-align: left;
    margin: 0 auto;
  }
`;